import { GlobalSetting } from '@/shared/domain/GlobalSetting';
import { SettingsRepository } from '@/shared/domain/SettingsRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';

export class SettingsUseCase implements UseCase<void, SfApiResponse<GlobalSetting>> {

  private repository: SettingsRepository;

  public constructor (repository: SettingsRepository) {
    this.repository = repository;
  }

  public async run (): Promise<SfApiResponse<GlobalSetting>> {
    return await this.repository.getSettings();
  }

}
